module.exports = __webpack_public_path__ + "assets/8b00b7bfb51583bacda563e5eeee739b.svg";